import { Box, Modal } from '@fairfashion/design-system'
import { createPortal } from 'react-dom'

import { ItemCard } from '../../../ItemCard/item-card.comp'
import { DeclarationData } from '../DeclarationData/declaration-data.comp'
import { ProviderData } from '../ProviderData/provider-data.comp'

import { ItemDetailsModalProps } from './virtual-item-details-modal.types'

export const VirtualItemDetailsModal = ({
  open,
  item,
  onClose,
}: ItemDetailsModalProps) => {
  return createPortal(
    <Modal
      open={open}
      onClose={() => onClose?.()}
      title="Detalhes do Item"
      width="100vw"
      height="100vh"
    >
      <Box width="100%" direction="column" gap={3}>
        <ItemCard
          icon="store2"
          title="Dados do Fornecedor"
          iconColor="primary"
          render={<ProviderData provider={item.provider} />}
        />
        {item.provider?.declaration && (
          <ItemCard
            icon="percent"
            title="Declaração"
            iconColor="purple"
            render={<DeclarationData declaration={item.provider.declaration} />}
          />
        )}
      </Box>
    </Modal>,
    document.body,
  )
}
